import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import AnomaliesPage from "./ui";

const Anomalies = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <AnomaliesPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default Anomalies;
